import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Action } from 'rxjs/internal/scheduler/Action';
import { Authorization } from '../../model/authorization';
import { AuthRoles_PTBR } from '../../model/AuthRoles';
import { Pipe, PipeTransform } from '@angular/core';
import { CompanyService } from '../../service/company.service';
import { ResidencesService } from '../../service/residences.service';
import { map } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthCompareComponent } from '../auth-compare/auth-compare.component';
import { AuthorizationService } from '../../service/authorizationService';
import { CompaniesModule } from '../../pages/companies/companies.module';
import { BasicAuthorization } from '../../model/basic-authorization';
import { UserService } from '../../service/user.service';
import { Essentials } from '../../util/essentials';
import { DatePipe } from '@angular/common';
import { Invite } from '../../model/invite';

@Component({
  selector: 'app-invite-card',
  templateUrl: './invite-card.component.html',
  styleUrls: ['./invite-card.component.css']
})
export class InviteCardComponent implements OnInit {

  @Input() invite: Invite;
  @Input() authorization: BasicAuthorization;
  @Input() lobbyRelease: boolean = false;
  @Output() cardClicked: EventEmitter<any> = new EventEmitter();
  @Output() onReleaseClicked: EventEmitter<any> = new EventEmitter();

  thumbnail: any = '';
  constructor(
    private essentials: Essentials,
    private userService: UserService,
    private modalservice: BsModalService,
    private authorizationService: AuthorizationService,
    public datepipe: DatePipe
    ) { 
      this.thumbnail = essentials.getDefaultAvatar();
    }

  ngOnInit(): void { 
    let updatedAt = Date.parse(this.authorization.userUpdatedAt);
    if (this.authorization.userId != 0) {
      this.userService.getThumbnail(this.authorization.userId, updatedAt.valueOf())
      .subscribe(data => { 
        this.thumbnail = data.thumbnail; 
      });
    }
  }

  isExpired() {
    let endDate = new Date(this.authorization.validPeriodEndsAt);
    let currentDate = new Date(Date.now());
    const result = endDate <= currentDate;
    return result;
  }

  onCardClick(){
    if (this.invite == undefined)
      return;
      
    this.cardClicked.emit(this.invite);
  }

  translate(role: string) {
    return AuthRoles_PTBR.hasOwnProperty(role) ? AuthRoles_PTBR[role] : role;
  }

  getFormatedInvitePeriod() {
    if (!this.isNullOrEmpty(this.authorization.validPeriodStartsAt) && !this.isNullOrEmpty(this.authorization.validPeriodEndsAt)) {
      let start = this.datepipe.transform(this.authorization.validPeriodStartsAt, 'dd/MM/yy HH:mm');      
      let end = this.datepipe.transform(this.authorization.validPeriodEndsAt, 'dd/MM/yy HH:mm');
      return `${start} - ${end}`;
    }
    return '--'
  }

  getFormatedValidPeriodStartsAt(){
    if (!this.isNullOrEmpty(this.authorization.validPeriodStartsAt)){
      let validPeriodStartsAt = new Date(this.authorization.validPeriodStartsAt)
      return this.datepipe.transform(validPeriodStartsAt, 'dd/MM/yy HH:mm');
    }
  }

  getFormatedValidPeriodEndsAt(){
    if (!this.isNullOrEmpty(this.authorization.validPeriodEndsAt)){
      let validPeriodEndsAt = new Date(this.authorization.validPeriodEndsAt)
      return this.datepipe.transform(validPeriodEndsAt, 'dd/MM/yy HH:mm');
    }
  }

  isNullOrEmpty(value: string) {
    return value == undefined || value == null || value.trim() == '';
  }

  releaseFromLobby() {
    if (this.authorization == undefined || this.isExpired())
      return;

    this.authorizationService.getById(this.authorization.id, false).subscribe((fullAuth: Authorization) => {
      this.onReleaseClicked.emit(fullAuth);
    }, ((error) => {
      console.log(error.message)
    }));
  }

  footerClicked() {
    if (this.showLobbyRelease) {
      this.releaseFromLobby();
    }
  }

  get hasRefuseMessage() {
    return !this.isNullOrEmpty(this.authorization.userUpdateStatusErrorMessage);
  }

  get getAccent() {
    if (this.authorization != undefined && !this.isExpired()) {
      const status_num: number = this.authorization.status;
      if (status_num == 0) // Autorizado
      return '#00d68f';
      if (status_num == 1) // Aguardando autorização
      return '#f58a42';
      if (status_num == 2) // Confirmado
      return '#f2f542';
      if (status_num == 3) // Aguardando confirmação (Agora é o status do convite)
      return '#898a86';
      if (status_num == 4) // Recusado
      return '#FF3D71';
      if (status_num == 5) // Cancelado
      return '#8F9BB3';
    }
    return '#AAAAAA';
  }

  get showLobbyRelease() {
    return this.lobbyRelease && this.authorization.waitOnLobby && this.authorization.userId != 0 && this.authorization.status < 3;
  }

}

